import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.addAnchorsToLinks();
  }

  addAnchorsToLinks() {
    // Get current anchor from URL
    const currentAnchor = window.location.hash;

    if (currentAnchor) {
      // Find all pagination links in this element
      const paginationLinks = this.element.querySelectorAll("a[href]");

      paginationLinks.forEach((link) => {
        const href = link.getAttribute("href");

        // Only add anchor if it doesn't already have one
        if (href && !href.includes("#")) {
          link.setAttribute("href", href + currentAnchor);
        }
      });
    }
  }
}
